import { Link } from 'react-router-dom'
import solarPanelImage from '../assets/images/solar_panelling_presentation.png'
import heatPumpImage from '../assets/images/heat_pump_presentation_homepage.png'

const ServicesOverview = () => {
  const services = [
    {
      title: 'Solar Panels',
      image: solarPanelImage,
      description: 'Harness the power of the sun with high-efficiency solar panel systems. Reduce your electricity bills and generate clean energy for your home.',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      link: '/solar-panels',
      features: ['25-year warranty', 'Smart monitoring', 'Battery storage options']
    },
    {
      title: 'Heat Pumps',
      image: heatPumpImage,
      description: 'Efficient heating and cooling with air source heat pumps reduce heating costs and carbon emissions while enjoying year round comfort.',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 12C9 10 8 6 12 4c4 2 3 6 0 8z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 12C9 10 8 6 12 4c4 2 3 6 0 8z" transform="rotate(120 12 12)" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 12C9 10 8 6 12 4c4 2 3 6 0 8z" transform="rotate(240 12 12)" />
          <circle cx="12" cy="12" r="1.6" strokeWidth="1.5" />
        </svg>
      ),
      link: '/heat-pumps',
      features: ['All-season comfort', 'Smart controls', 'Government grants']
    }
  ]

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="mb-4">Our Renewable Energy Solutions</h2>
          <p className="text-body-lg text-neutral-taupe max-w-3xl mx-auto">
            Discover our comprehensive range of renewable energy solutions designed to reduce your 
            energy costs, increase your property value, and contribute to a sustainable future.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 items-stretch">
          {services.map((service) => (
            <div
              key={service.title}
              className="flex-1 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group flex flex-col"
            >
              <div className="flex-1 flex">
                <div className="w-1/2 p-8">
                  <div className="w-20 h-20 bg-primary-green bg-opacity-10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary-green group-hover:text-white transition-all duration-300">
                    <div className="text-primary-green group-hover:text-white transition-colors duration-300">
                      {service.icon}
                    </div>
                  </div>

                  <h3 className="text-2xl font-bold mb-4 text-dark-plum">{service.title}</h3>
                  <p className="text-neutral-taupe mb-6">{service.description}</p>

                  <ul className="space-y-2 mb-8">
                    {service.features.map((feature) => (
                      <li key={feature} className="flex items-center text-sm text-neutral-taupe">
                        <svg className="w-4 h-4 text-primary-green mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <Link
                    to={service.link}
                    className="inline-flex items-center text-primary-green hover:text-primary-green-dark font-medium transition-colors duration-200"
                  >
                    Learn More
                    <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>

                <img
                  src={service.image}
                  alt={service.title}
                  className="w-1/2 h-full object-cover"
                />
              </div>

              <div className="h-1 bg-gradient-to-r from-primary-green to-primary-green-dark transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServicesOverview